// Updated input filtering functions to handle specific field requirements
export // Updated input filtering functions to handle specific field requirements
const filterInputByType = (
  value: string,
  type: string,
  columnKey?: string
): string => {
  // Special handling for specific fields that should allow numbers only
  const numericFields = [
    "Pincode",
    "Emergency Contact",
    "Mobile Number",
    "pincode",
    "emergency_contact",
    "mobile_number",
  ];
  const isNumericField = numericFields.includes(columnKey || "");

  // Special handling for fields that should allow both numbers and text
  const alphanumericFields = [
    "Package Ref.ID",
    "Biometric Identification Number (BIN)",
    "package_ref_id",
    "biometric_identification_number",
    "bin",
  ];
  const isAlphanumericField = alphanumericFields.includes(columnKey || "");

  switch (type) {
    case "number":
      // Allow only numbers, decimal point, and minus sign
      return value.replace(/[^0-9.-]/g, "");

    case "email":
      // Allow alphanumeric, @, ., -, _, +
      return value.replace(/[^a-zA-Z0-9@._+-]/g, "");

    case "phone":
      // Allow only numbers, +, -, (, ), and spaces
      return value.replace(/[^0-9+\-() ]/g, "");

    case "url":
      // Allow alphanumeric, common URL characters
      return value.replace(/[^a-zA-Z0-9:/.?=&_-]/g, "");

    case "text":
    default:
      // Special handling for numeric fields (Pincode, Emergency Contact, Mobile Number)
      if (isNumericField) {
        return value.replace(/[^0-9]/g, ""); // Allow only numbers
      }
      // Special handling for alphanumeric fields (Package Ref.ID, BIN)
      else if (isAlphanumericField) {
        return value.replace(/[<>{}^&*%$#@!)(+_?":;]/g, ""); // Allow numbers, letters, and some special chars
      }
      // Special handling for Address Line 1 - allow numbers, letters, and some special chars
      else if (
        columnKey === "Address Line 1" ||
        columnKey === "address_line_1"
      ) {
        return value.replace(/[<>{}^&*%$#@!)(+_?":;]/g, "");
      }
      // For other text fields, remove numbers and special characters
      else {
        return value.replace(/[<>{}^&*%$#@!)(+_?":;0-9]/g, "");
      }
  }
};

// Updated handleKeyPress function
export const handleKeyDown = (
  event: React.KeyboardEvent,
  type: string,
  columnKey?: string
) => {
  const char = event.key;

  // Allow control keys (Backspace, Delete, Tab, Enter, Arrow keys, etc.)
  const controlKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "Insert",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
  ];

  // Allow Ctrl/Cmd combinations (Copy, Paste, Cut, Select All, etc.)
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  // Allow control keys
  if (controlKeys.includes(char)) {
    return;
  }

  // Special handling for specific fields that should allow numbers only
  const numericFields = [
    "Pincode",
    "Emergency Contact",
    "Mobile Number",
    "pincode",
    "emergency_contact",
    "mobile_number",
  ];
  const isNumericField = numericFields.includes(columnKey || "");

  // Special handling for fields that should allow both numbers and text
  const alphanumericFields = [
    "Package Ref.ID",
    "Biometric Identification Number (BIN)",
    "package_ref_id",
    "biometric_identification_number",
    "bin",
  ];
  const isAlphanumericField = alphanumericFields.includes(columnKey || "");

  switch (type) {
    case "number":
      if (!/[0-9.-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "email":
      if (!/[a-zA-Z0-9@._+-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "phone":
      if (!/[0-9+\-() ]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "url":
      if (!/[a-zA-Z0-9:/.?=&_-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "text":
      // Special handling for numeric fields (Pincode, Emergency Contact, Mobile Number)
      if (isNumericField) {
        if (!/[0-9]/.test(char)) {
          event.preventDefault();
        }
      }
      // Special handling for alphanumeric fields (Package Ref.ID, BIN)
      else if (isAlphanumericField) {
        if (/[<>{}^&*%$#@!)(+_?":;]/.test(char)) {
          event.preventDefault();
        }
      }
      // Special handling for Address Line 1 - allow numbers, letters, and some special chars
      else if (
        columnKey === "Address Line 1" ||
        columnKey === "address_line_1"
      ) {
        if (/[<>{}^&*%$#@!)(+_?":;]/.test(char)) {
          event.preventDefault();
        }
      }
      // For other text fields, prevent numbers and special characters
      else {
        if (/[<>{}^&*%$#@!)(+_?":;0-9]/.test(char)) {
          event.preventDefault();
        }
      }
      break;
  }
};
